/* ============
 * Templates Actions
 * ============
 *
 * The actions available for the templates module.
 */

import i18n from '@/i18n';
import store from '@/store';
import api from '../../../api/masks';
import * as types from './types';

export default {
  getMasks({ commit }) {
    store.dispatch('application/startLoading');
    return api.getMasks()
      .then((response) => {
        commit(types.SET_MASKS, response);
        store.dispatch('application/finishLoading');
        return response;
      },
      )
      .catch(() => {
        store.dispatch('application/finishLoading');
        store.dispatch('application/openSnackbar', {
          message: i18n.t('masks.get.error'),
        });
      });
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/masks/actions.js